import { clickOutside } from '@portal/utils/util-click-outside';
import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-tooltip.styles.scss?module';

interface Events {
  onClick: Event;
  onClickOutside: void;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiTooltip',
    mounted() {
      if (this.$refs.tooltipWrap !== null) {
        clickOutside(this.$refs.tooltip as HTMLElement, () => this.clickOutside());
      }
    },
    methods: {
      clickOutside() {
        this.$emit('clickOutside');
      }
    },
    render() {
      const attributes = {
        attrs: this.$attrs,
        on: this.$listeners
      };

      return (
        <div ref="tooltip" class={styles.tooltip} {...attributes}>
          {this.$slots.default}
        </div>
      );
    }
  });
